import React, { useMemo } from 'react';
import { createArrayInRange } from '@visalex/core';

import { useTranslation } from 'next-i18next';

import { BenefitProps } from '../../Benefits/Benefits';
import Features from '../Features/Features';

const prefix = 'technology';

const Languages = () => {
  const { t, i18n } = useTranslation();
  const benefits: BenefitProps[] = useMemo(
    () =>
      createArrayInRange(0, 7).map((index) => ({
        key: index,
        imageName: `${prefix}/languages/icon_${index + 1}.svg`,
        imageAlt: t(`${prefix}.languages.benefits.${index}.title`),
      })),
    [i18n.language]
  );

  return (
    <Features
      title={t(`${prefix}.languages.title`)}
      subtitle={t(`${prefix}.languages.subtitle`)}
      benefits={benefits}
      colProps={{ xs: 6, sm: 4, md: 3, xl: 3 }}
    />
  );
};

export default Languages;
